/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forside_Preview_CheckInputs */

const da_forside_preview_check = /** @type {(inputs: Forside_Preview_CheckInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tjek`)
};

/** @type {(inputs: Forside_Preview_CheckInputs) => LocalizedString} */
const en_forside_preview_check = da_forside_preview_check;

/**

* @param {Forside_Preview_CheckInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const forside_preview_check = /** @type {((inputs?: Forside_Preview_CheckInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forside_Preview_CheckInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forside_preview_check(inputs)
	return /** @type {LocalizedString} */ ("Tjek")
});